'use client';

import { c as _c } from "react/compiler-runtime";
import { getCookie } from 'cookies-next';
import { useSelectedLayoutSegments } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import { constants } from '@/data/constants';
export const Html: React.FC<PropsWithChildren> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const segments = useSelectedLayoutSegments();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCookie(constants.COOKIE_NAME_COLOR_SCHEME) as 'light' | 'dark' | undefined ?? undefined;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let scheme = t1;
  if (["(authenticated)", "(public)"].includes(segments[0])) {
    scheme = "dark";
  } else {
    scheme = scheme ?? "dark";
  }
  let t2;
  if ($[1] !== children || $[2] !== scheme) {
    t2 = <html data-mantine-color-scheme={scheme} dir="ltr" lang="de" suppressHydrationWarning={true}>{children}</html>;
    $[1] = children;
    $[2] = scheme;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};